import React, { ComponentType } from 'react'
import { AppContext } from 'src/context/AppContext'
import { App } from 'src/App'
import { StylingProvider } from 'src/ui/style/StylingProvider'
import { RoutingProvider } from '@core'
import { I18nProvider } from 'src/i18n/I18nProvider'
// import { ScrollContextProvider } from 'src/lib/scroll/ScrollContext'
import { headerDimension } from 'src/layout/header/Header'
// import { AppErrorHandling } from 'src/error/AppErrorHandling'
import { ChatbotProvider } from './ui/chatbot'
import { WithAppContext } from './context/WithAppContext'
import { WithScroll } from 'src/lib/scroll/WithScroll'
import { WithErrorHandling } from 'src/error/WithErrorHandling'
import { EcomailWidget } from 'src/marketing/EcomailWidget'

type RootProps = {
    ctx: AppContext
}

export const Root: ComponentType<RootProps> = ({ ctx }) => {
    if (ctx.config.maintenance) {
        return (
            <img
                src="https://boxyland.s3.eu-west-3.amazonaws.com/public/meta-assets/maintenance.png"
                alt={'Maintenance'}
            />
        )
    }

    // const handleMessages = async (message: string): Promise<string> => {
    //     const messageText = message.trim()
    //
    //     const response = await axios.post<{ answer: string }>(
    //         '/ask',
    //         {
    //             question: messageText
    //         },
    //         {
    //             headers: {
    //                 'Content-Type': 'application/json'
    //             }
    //         }
    //     )
    //
    //     console.log('Response from server:', response.data)
    //
    //     // For testing, you can return a simple response
    //     return response.data.answer
    //
    //     // In production, you would typically:
    //     // 1. Send the message to your backend API
    //     // 2. Wait for a response
    //     // 3. Return the response to the chatbot
    //     // const response = await api.sendChatMessage(message)
    //     // return response.text
    // }

    return (
        <WithAppContext ctx={ctx}>
            <RoutingProvider router={ctx.router}>
                <I18nProvider ctx={ctx}>
                    <WithScroll offset={headerDimension.approximateFixedHeight}>
                        <WithErrorHandling>
                            <StylingProvider>
                                <ChatbotProvider buttonLabel="Potrebuješ pomoc?">
                                    <EcomailWidget />
                                    <App pages={ctx.router.pages} />
                                </ChatbotProvider>
                            </StylingProvider>
                        </WithErrorHandling>
                    </WithScroll>
                </I18nProvider>
            </RoutingProvider>
        </WithAppContext>
    )
}

export default Root
